import React, { useRef, useState } from "react";
import "../../App.css";
import { NavLink } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import CreateItemForm from "./CreateItemForm";
import { confirmAlert } from "react-confirm-alert";

const CreateItems = () => {

  const formRef = useRef();
  // const navigate = useNavigate();

  const [edit, setEdit] = useState(false);

  const confirmBack = () => {
    if (edit) {
      confirmAlert({
        title: "Back to Item Page",
        message: `If you go back now, any unsaved changes will be lost. Are you sure you want to continue?`,
        buttons: [
          {
            label: "Yes",
            onClick: () => goBack(),
          },
          {
            label: "No",
          },
        ],
      });
    } else {
      goBack();
    }
  };

  const goBack = () => {
    // navigate("/items");
    window.history.back();
  };

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  };

  return (
    <div>
      <nav className="bg-[#0D868C] shadow-md md:p-4 py-2 px-4 flex justify-between items-center sticky top-0 z-20 ">
        <div className="md:text-[1rem] text-[.9rem] font-inter-600 text-white flex items-center gap-3 ml-3">
          {/* <NavLink to={"/items"}> */}
          <IoIosArrowBack
            onClick={() => confirmBack()}
            title="Go Back"
            className="size-8 cursor-pointer bg-[#a9a9a9] rounded-xl p-1"
          />
          {/* </NavLink> */} Create Item
        </div>
        <NavLink onClick={handleSubmit} title="Create New Item">
          <button className="md:text-[1rem] text-[.9rem] font-inter-600 text-white bg-[#a9a9a9] py-1 px-3 rounded-md flex items-center uppercase mr-3">
            Save
          </button>
        </NavLink>
      </nav>

      <div>
        <CreateItemForm ref={formRef} setEdit={setEdit} />
      </div>
    </div>
  );
};

export default CreateItems;
